<template>
  <el-dialog
    :model-value="isOpen"
    width="744px"
    :modal-append-to-body="false"
    @close="$emit('close')"
  >
    <h1 class="tw-leading-[38px] tw-tracking-wider tw-mb-6">
      {{ $t('messaging.new_thread') }}
    </h1>
    <div class="tw-flex tw-flex-col tw-mt-2">
      <template
        v-for="(permit, index) in canBeOpenedThreads"
        :key="permit.id"
      >
        <div
          v-if="index !== 0"
          class="tw-bg-gray tw-w-full tw-h-px tw-my-2"
        />
        <ForeignersNewThreadItem
          :permit="permit"
          :foreigner="foreigner"
          :store-path="storePath"
          @new-thread="$emit('close')"
        />
      </template>
    </div>
  </el-dialog>
</template>

<script>
import ForeignersNewThreadItem from '@/components/Foreigners/Messaging/ForeignersNewThreadItem.vue';

export default {
  name: 'ForeignersNewThreadDialog',
  components: { ForeignersNewThreadItem },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    storePath: {
      type: String,
      required: true,
    },
  },
  computed: {
    stateFragment() {
      const pathArray = this.storePath.split('/');
      let fragment = this.$store.state;
      pathArray.forEach((path) => {
        fragment = fragment[path];
      });
      return fragment;
    },
    foreigner() {
      return this.stateFragment.foreigner;
    },
    canBeOpenedThreads() {
      return this.$store.getters[`${this.storePath}/canBeOpenedThreads`];
    },
  },
};
</script>
